import React, { useCallback, useEffect, useRef } from 'react';
import { TaskForm } from '../../../../reducers/taskFormType';
import { Button, CircularProgress } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import WarnIcon from '@material-ui/icons/Warning';
import { ajax, AjaxError } from 'rxjs/ajax';
import useRemoteData from 'util/hooks/useRemoteData';

// just to make API happy. It's just what the modeler saves.
const formImageBase64 =
    'data:image/png;base64,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';
interface SaveFormToModelerButtonProps {
    formDefinition: TaskForm;
    formId: string;
    modelerUrl: string;
}
const SaveFormToModelerButton: React.FC<SaveFormToModelerButtonProps> = ({ formDefinition, formId, modelerUrl }) => {
    const { state, fold, setSuccess, setPending, setError } = useRemoteData();
    const prevStatus = useRef(state.status);
    useEffect(() => {
        if (prevStatus.current !== 'pending' && state.status === 'pending') {
            const $ajax = ajax({
                url: modelerUrl + '/modeler/app/rest/form-models/' + formId,
                method: 'PUT',
                headers: {
                    Accept: 'application/json, text/plain, */*',
                    'Content-Type': 'application/json;charset=UTF-8',
                },
                withCredentials: true,
                responseType: 'json',
                body: {
                    formRepresentation: {
                        formDefinition,
                        id: formId,
                        name: formDefinition.name,
                        key: formDefinition.key,
                        // description
                    },
                    formImageBase64,
                },
            });

            const subscription = $ajax.subscribe(
                (res) => {
                    setSuccess(res.response);
                },
                (error: AjaxError) => {
                    setError(error);
                },
            );
            prevStatus.current = state.status;
            return () => {
                if (!subscription.closed) {
                    subscription.unsubscribe();
                }
            };
        }
        prevStatus.current = state.status;
    }, [state.status, formDefinition, formId, modelerUrl, setError, setSuccess]);
    const save = useCallback(() => {
        setPending();
    }, [setPending]);
    return (
        <Button
            disabled={fold(
                () => false,
                () => true,
                () => false,
                () => false,
            )}
            onClick={save}
            variant="contained"
            color="primary"
        >
            <>
                Save to modeler
                {fold(
                    () => null,
                    () => (
                        <>
                            &nbsp;
                            <CircularProgress size={25} thickness={2} />
                        </>
                    ),
                    () => (
                        <>
                            &nbsp;
                            <CheckIcon />
                        </>
                    ),
                    () => (
                        <>
                            &nbsp;
                            <WarnIcon />
                        </>
                    ),
                )}
            </>
        </Button>
    );
};
export default SaveFormToModelerButton;
